import styled from "styled-components";

const StyledOurTeam = styled.section`
margin-top: var(--section-spacing);
`

export {StyledOurTeam}